import { render, staticRenderFns } from "./itemList.vue?vue&type=template&id=1e62e802"
import script from "./itemList.vue?vue&type=script&lang=js"
export * from "./itemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports